/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useRef } from "react";
import useModel3D from "./three/hooks/useModel3D";
import useCustomizableContext from "~/CustomizableToolPage/useCustomizableContext";

const ModelScene = () => {
  const {
    // @ts-ignore
    modelData,
    // @ts-ignore
    regionData,
    // @ts-ignore
    selectedRegion,
    itemNumberId,
    // @ts-ignore
    fabric: { fabricMounted },
  } = useCustomizableContext();

  const containerId = "preview-3d-container";
  const containerRef = useRef<HTMLDivElement>(null);
  // @ts-ignore
  const { initScene } = useModel3D();

  useEffect(() => {
    if (fabricMounted) {
      initScene(
        modelData,

        // @ts-ignore
        containerRef,
        regionData[selectedRegion]!.model.position,
        regionData[selectedRegion]!,
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelData, fabricMounted, itemNumberId]);

  return <div ref={containerRef} id={containerId} />;
};

export default ModelScene;
